import React, { useEffect, useState } from 'react';
import { Container, Grow, Grid, Paper } from '@material-ui/core';

import HotspotsPagination from './HotspotsPagination';
import { Hotspots } from "./Hotspots";
import { useDispatch } from 'react-redux';

import { useLocation } from 'react-router-dom';

import { getHotspots } from '../../actions/hotspots';
import { UpcomingSignalsPanel } from '../Events/UpcomingSignalsPanel';
import { RegionalChecklistPanel } from '../Checklists/RegionalChecklistPanel';
import { getDiscoveryTheme, readDiscoveryTheme } from '../../lib/discoveryThemes';
import { ThemeSwitch } from '../Theme/ThemeSwitch';


function useQuery() {
    return new URLSearchParams(useLocation().search)
}

export const HotspotsPage = (props) => {
    const location = useLocation();
    const query = useQuery();
    const page = query.get('page') || 1;
    const initialTab = query.get('tab') === 'checklist' ? 'checklist' : 'hotspots';
    const activeTheme = readDiscoveryTheme(location.search);
    const themeConfig = getDiscoveryTheme(activeTheme);
    const [activeTab, setActiveTab] = useState(initialTab);

    const dispatch = useDispatch();

    // Only run once, pagination page will take over once vars are populated
    useEffect(() => {
        dispatch(getHotspots(page));
    }, [page, dispatch]);

    useEffect(() => {
        setActiveTab(initialTab);
    }, [initialTab]);

    return (
        <Grow in>
            <Container className="atlas-route-shell">
                <div className="atlas-page-header">
                    <span className="atlas-eyebrow">Discovery stream</span>
                    <h1>{themeConfig.hotspots.title}</h1>
                    <p>{themeConfig.hotspots.description}</p>
                </div>
                <ThemeSwitch className="atlas-theme-switch--page" overrides={{ page: 1, tab: activeTab }} />
                <div className="atlas-tab-strip" role="tablist" aria-label="Hotspots views">
                    <button
                        type="button"
                        role="tab"
                        aria-selected={activeTab === 'hotspots'}
                        className={`atlas-tab-button ${activeTab === 'hotspots' ? 'is-active' : ''}`}
                        onClick={() => setActiveTab('hotspots')}
                    >
                        Hotspots
                    </button>
                    <button
                        type="button"
                        role="tab"
                        aria-selected={activeTab === 'checklist'}
                        className={`atlas-tab-button ${activeTab === 'checklist' ? 'is-active' : ''}`}
                        onClick={() => setActiveTab('checklist')}
                    >
                        Regional checklist
                    </button>
                </div>

                {activeTab === 'hotspots' ? (
                    <>
                        <div className="atlas-section atlas-section--tight">
                            <UpcomingSignalsPanel
                                lat={props.lat}
                                lng={props.lng}
                                title="Live hotspots near this point"
                                description="The old published hotspot archive is sparse right now, so this live view uses nearby Tellus signals to show places and moments worth checking instead of leaving the page empty."
                            />
                        </div>
                        <Grid container justifyContent="space-between" alignItems="stretch" spacing={3}>
                            <Grid item xs={12} md={8}>
                                <Hotspots />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Paper elevation={6} className="atlas-sidebar-card">
                                    <div className="atlas-sidebar-copy">
                                        <h3>Published hotspot archive</h3>
                                        <p>
                                            Legacy hotspot cells still render here when they exist,
                                            but the live panel above is now the primary path so this
                                            route stays useful even when the old archive is empty.
                                        </p>
                                    </div>
                                    <HotspotsPagination page={page} />
                                </Paper>
                            </Grid>
                        </Grid>
                    </>
                ) : (
                    <div className="atlas-section atlas-section--tight">
                        <RegionalChecklistPanel lat={props.lat} lng={props.lng} />
                    </div>
                )}
            </Container>
        </Grow>
    )
}

// TODO: Add a dynamic map component which shows only visible markers on a graph
// import React, { useState, useEffect } from 'react';
// import { GoogleMap, Marker, InfoWindow } from 'react-google-maps';

// const MapWithVisibleMarkers = ({ markers }) => {
//   const [visibleMarkers, setVisibleMarkers] = useState([]);

//   // Function to determine visible markers based on map bounds
//   const handleMapChanged = (map) => {
//     if (!map) return;

//     const bounds = map.getBounds();
//     const visibleMarkers = markers.filter(marker =>
//       bounds.contains(marker.position)
//     );

//     setVisibleMarkers(visibleMarkers);
//   };

//   // useEffect to initialize visible markers on load and handle map changes
//   useEffect(() => {
//     const initialVisibleMarkers = markers.filter(marker =>
//       map.getBounds().contains(marker.position)
//     );
//     setVisibleMarkers(initialVisibleMarkers);

//     // Event listener for map changes
//     map.addListener('bounds_changed', () => handleMapChanged(map));

//     return () => {
//       // Clean up event listener
//       map.removeListener('bounds_changed', handleMapChanged);
//     };
//   }, []);

//   return (
//     <div style={{ display: 'flex', flexDirection: 'row' }}>
//       <div style={{ flex: '1', height: '400px' }}>
//         <GoogleMap
//           defaultZoom={8}
//           defaultCenter={{ lat: 37.7749, lng: -122.4194 }}
//           onUnmount={handleMapChanged} // Ensure map changes trigger re-evaluation of visible markers
//         >
//           {markers.map((marker, index) => (
//             <Marker
//               key={index}
//               position={marker.position}
//             />
//           ))}
//         </GoogleMap>
//       </div>
//       <div style={{ flex: '1', height: '400px', overflowY: 'scroll' }}>
//         <h3>Visible Markers:</h3>
//         <ul>
//           {visibleMarkers.map((marker, index) => (
//             <li key={index}>
//               Marker {index + 1}: {marker.name} ({marker.position.lat()}, {marker.position.lng()})
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default MapWithVisibleMarkers;
